module.exports = __webpack_public_path__ + "static/media/work.e35948ed.png";